import * as React from "react";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setHintsEnabled } from "@mancala/core";
import { Context } from "../context/context";
import Util from "../util/Util";

// The tutorial's last step: a game against the Easy bot with hints on (R3.1).
const PracticeGameCard: FunctionComponent<{ context: Context }> = ({ context }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const start = () => {
        if (Util.checkConnectionAndMaybeAlert(context, t)) return;
        setHintsEnabled(context.storage, true);
        navigate("/loby?bot=easy");
    };
    return (
        <section className="practice panel">
            <div>
                <strong>{t("PracticeGame")}</strong>
                <p>{t("PracticeGameText")}</p>
            </div>
            <button className="btn pri" onClick={start}>{t("PlayWithBot")}</button>
            <style jsx>{`
                .practice {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 12px;
                    padding: 18px 22px;
                    flex-shrink: 0;
                }
                strong {
                    font-size: 18px;
                }
                p {
                    margin: 4px 0 0;
                    color: var(--muted);
                }
            `}</style>
        </section>
    );
};

export default PracticeGameCard;
